import type { FaireProductEntity } from "../../entity_types/product";

export const p_trm9t5dshf: FaireProductEntity = {
  token: "p_trm9t5dshf",
  type: "product",
  name: "Bison Magnetic Notepad | Lined Pages | Made in USA",
  brandName: "Counter Couture",
  imageUrl:
    "https://cdn.faire.com/fastly/1fa695c23491b0242cd953a24a468e8de6936fb70687437808d4685dc4ffc768.jpeg",
  priceDollars: 4,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/res/hszgttpjt/image/upload/d9f6488cdb461e0966a67b975c331ddb1539d9e2dbf6e6d9052ba4a325a83719/1563903613.jpg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
